(function () {
  var LS_KEY = 'partbot_selected_vehicle';
  var EVENTS = ['vehicle-garage-change', 'vehicle-search-change', 'plate-search-change', 'partbot-clear-vehicle'];
  var TILE_COUNT = 4;
  var best = null;

  function uc(x) {
    return String(x == null ? '' : x).toUpperCase();
  }

  function esc(str) {
    var d = document.createElement('div');
    d.textContent = String(str == null ? '' : str);
    return d.innerHTML;
  }

  function titleCase(str) {
    if (!str) return '';
    var w = String(str).toLowerCase().split(' ');
    for (var i = 0; i < w.length; i++) {
      if (!w[i]) continue;
      w[i] = w[i].charAt(0).toUpperCase() + w[i].slice(1);
      if (w[i] === 'Landcruiser') w[i] = 'LandCruiser';
    }
    return w.join(' ');
  }

  function readVehicle() {
    try {
      var sel = JSON.parse(localStorage.getItem(LS_KEY));
      var v = sel && sel.vehicle;
      return v && (v.make || v.model) ? v : null;
    } catch (e) {
      return null;
    }
  }

  function openGarage() {
    var t = document.querySelectorAll('[data-garage-trigger]');
    for (var i = 0; i < t.length; i++) {
      if (!t[i].closest('.mega-menu')) {
        t[i].click();
        return;
      }
    }
    if (t[0]) t[0].click();
  }

  function storefront() {
    var a = document.querySelector('[data-partbot-order-attribution]');
    var token = a && a.getAttribute('data-storefront-access-token');
    if (!token) return null;
    return { token: token, ver: a.getAttribute('data-storefront-api-version') || '2024-07' };
  }

  function parseList(raw, splitComma) {
    var out = [];
    if (!raw) return out;
    try {
      JSON.parse(raw).forEach(function (entry) {
        if (!splitComma) return out.push(uc(entry));
        String(entry).split(',').forEach(function (s) {
          s = s.trim().toUpperCase();
          if (s) out.push(s);
        });
      });
    } catch (e) {}
    return out;
  }

  // Only confirmed fits make the best sellers column. The rule lives once, in
  // snippets/pb-grid-fit-sort (window.pbFit).
  function fits(vehicle, p) {
    return !!window.pbFit && window.pbFit.state(vehicle, p.tokens, p.series) === 'fits';
  }

  /*
    Best sellers are fetched 20 at a time, stopping as soon as TILE_COUNT of
    them fit the vehicle (usually the first page). Pages already fetched are
    kept, so a vehicle change only fetches more when the shown ones run out.
  */
  var PAGE_SIZE = 20;
  var MAX_PAGES = 5;
  var fetched = [];
  var pagesFetched = 0;
  var cursor = null;
  var hasMore = true;

  function fetchPage() {
    var sf = storefront();
    if (!sf) {
      hasMore = false;
      return Promise.resolve();
    }
    var q =
      'query($after: String) { products(first: ' + PAGE_SIZE + ', after: $after, sortKey: BEST_SELLING) {' +
      ' pageInfo { hasNextPage endCursor } nodes { title handle onlineStoreUrl' +
      ' featuredImage { url } priceRange { minVariantPrice { amount currencyCode } }' +
      ' yt: metafield(namespace: "app--1585807--partbot", key: "vehicle_year_tokens") { value }' +
      ' sr: metafield(namespace: "app--1585807--partbot", key: "vehicle_series") { value }' +
      ' } } }';
    return fetch('/api/' + sf.ver + '/graphql.json', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': sf.token },
      body: JSON.stringify({ query: q, variables: { after: cursor } })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (j) {
        var conn = j && j.data && j.data.products;
        var nodes = (conn && conn.nodes) || [];
        pagesFetched++;
        cursor = conn && conn.pageInfo ? conn.pageInfo.endCursor : null;
        hasMore = !!(conn && conn.pageInfo && conn.pageInfo.hasNextPage) && pagesFetched < MAX_PAGES;
        nodes.forEach(function (n) {
          var pr = n.priceRange && n.priceRange.minVariantPrice;
          fetched.push({
            title: n.title,
            url: n.onlineStoreUrl || '/products/' + n.handle,
            image: n.featuredImage ? n.featuredImage.url : null,
            amount: pr ? pr.amount : null,
            currency: pr ? pr.currencyCode : 'AUD',
            tokens: parseList(n.yt && n.yt.value, false),
            series: parseList(n.sr && n.sr.value, true)
          });
        });
      })
      .catch(function () {
        hasMore = false;
      });
  }

  // The first TILE_COUNT best sellers that fit the vehicle.
  function load(vehicle) {
    var picked = fetched.filter(function (p) {
      return fits(vehicle, p);
    });
    if (picked.length >= TILE_COUNT || !hasMore) return Promise.resolve(picked.slice(0, TILE_COUNT));
    if (!best) {
      best = fetchPage().then(function () {
        best = null;
      });
    }
    return best.then(function () {
      return load(vehicle);
    });
  }

  function money(amount, currency) {
    var n = parseFloat(amount);
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'AUD' }).format(n);
    } catch (e) {
      return '$' + n.toFixed(2);
    }
  }

  function tile(p, tick) {
    var img = p.image
      ? '<img src="' + esc(p.image.split('?')[0]) + '?width=300" alt="" loading="lazy" width="300" height="225">'
      : '';
    return (
      '<a class="mega-menu__tile" href="' + esc(p.url) + '">' +
      '<span class="mega-menu__tile-media">' + img + '</span>' +
      '<span class="mega-menu__tile-title">' + esc(p.title) + '</span>' +
      '<span class="mega-menu__tile-price">' + money(p.amount, p.currency) + '</span>' +
      '<span class="cvf-fit cvf-fit--fits"><span class="cvf-fit__badge" aria-hidden="true">' + tick + '</span>Fitment match</span>' +
      '</a>'
    );
  }

  function label(v) {
    var parts = [];
    if (v.year) parts.push(v.year);
    if (v.make) parts.push(titleCase(v.make));
    if (v.model) parts.push(titleCase(v.model));
    var out = parts.join(' ');
    if (v.series) out += ' ' + titleCase(v.series);
    return out;
  }

  /*
    The best sellers (100 products) are only fetched once the shopper reaches
    for a column menu (hover, focus or open), not on every page view.
  */
  var wanted = false;
  function want() {
    if (wanted) return;
    wanted = true;
    render();
  }

  function render() {
    var cols = document.querySelectorAll('[data-mm-feature]');
    if (!cols.length) return;
    var vehicle = readVehicle();
    var i;

    for (i = 0; i < cols.length; i++) {
      var head = cols[i].querySelector('[data-mm-head]');
      var prompt = cols[i].querySelector('[data-mm-prompt]');
      var tiles = cols[i].querySelector('[data-mm-tiles]');
      if (vehicle) {
        head.textContent = 'Best sellers for your ' + label(vehicle);
        prompt.hidden = true;
        tiles.hidden = false;
      } else {
        head.textContent = 'Shop for your vehicle';
        prompt.hidden = false;
        tiles.hidden = true;
        tiles.innerHTML = '';
      }
    }

    if (!vehicle || !wanted) return;

    load(vehicle).then(function (picked) {
      if (readVehicle() !== null && label(readVehicle()) !== label(vehicle)) return;
      for (var k = 0; k < cols.length; k++) {
        var tickEl = cols[k].querySelector('[data-mm-tick]');
        var tick = tickEl ? tickEl.innerHTML : '';
        cols[k].querySelector('[data-mm-tiles]').innerHTML = picked
          .map(function (p) {
            return tile(p, tick);
          })
          .join('');
      }
    });
  }

  function initMenu(details) {
    var cols = details.querySelector('.mega-menu__cols');
    var cats = Array.prototype.slice.call(details.querySelectorAll('.mega-menu__cat'));
    var panels = Array.prototype.slice.call(details.querySelectorAll('.mega-menu__panel'));
    if (!cols || !cats.length || !panels.length) return;
    var def = cols.getAttribute('data-mm-default') || cats[0].getAttribute('data-mm-panel');

    function activate(index) {
      cats.forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-mm-panel') === index);
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-mm-panel') === index);
      });
    }

    cats.forEach(function (cat, i) {
      cat.addEventListener('mouseenter', function () {
        activate(cat.getAttribute('data-mm-panel'));
      });
      cat.addEventListener('focus', function () {
        activate(cat.getAttribute('data-mm-panel'));
      });
      cat.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' && cats[i + 1]) {
          e.preventDefault();
          cats[i + 1].focus();
        } else if (e.key === 'ArrowUp' && cats[i - 1]) {
          e.preventDefault();
          cats[i - 1].focus();
        } else if (e.key === 'ArrowRight') {
          var t = details.querySelector('.mega-menu__panel.is-active .mega-menu__type');
          if (t) {
            e.preventDefault();
            t.focus();
          }
        }
      });
    });

    details.addEventListener('toggle', function () {
      if (details.open) activate(def);
    });
  }

  function trackActive() {
    var nav = document.querySelector('.header__inline-menu');
    if (!nav) return;
    var hms = Array.prototype.slice.call(nav.querySelectorAll('header-menu'));
    if (!hms.length) return;
    var clearTimer;

    function setActive(target) {
      clearTimeout(clearTimer);
      hms.forEach(function (hm) {
        hm.classList.toggle('mm-active', hm === target);
      });
    }

    var items = Array.prototype.slice.call(nav.querySelectorAll('li'));
    items.forEach(function (li) {
      var hm = li.querySelector('header-menu');
      li.addEventListener('mouseenter', function () {
        setActive(hm);
      });
      li.addEventListener('focusin', function () {
        setActive(hm);
      });
    });

    nav.addEventListener('mouseleave', function () {
      clearTimeout(clearTimer);
      clearTimer = setTimeout(function () {
        setActive(null);
      }, 160);
    });

    nav.addEventListener('focusout', function (e) {
      if (!nav.contains(e.relatedTarget)) setActive(null);
    });
  }

  function placeSimple() {
    var header = document.querySelector('.header');
    if (!header) return;
    var bottom = header.getBoundingClientRect().bottom;
    var simples = document.querySelectorAll('.mega-menu--simple');
    for (var i = 0; i < simples.length; i++) {
      var content = simples[i].querySelector('.mega-menu__content');
      if (!content) continue;
      content.style.top = Math.round(bottom - simples[i].getBoundingClientRect().top) + 'px';
    }
  }

  function boot() {
    var menus = document.querySelectorAll('.mega-menu--columns');
    for (var i = 0; i < menus.length; i++) {
      initMenu(menus[i]);
      ['pointerenter', 'focusin', 'toggle'].forEach(function (type) {
        menus[i].addEventListener(type, want, { passive: true });
      });
    }
    trackActive();

    placeSimple();
    window.addEventListener('resize', placeSimple);
    document.querySelectorAll('.mega-menu--simple').forEach(function (d) {
      d.addEventListener('toggle', placeSimple);
      d.addEventListener('mouseenter', placeSimple);
    });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-mm-add-vehicle]');
      if (!btn) return;
      e.preventDefault();
      openGarage();
    });

    render();
    EVENTS.forEach(function (name) {
      window.addEventListener(name, render);
      document.addEventListener(name, render);
    });
    window.addEventListener('storage', function (e) {
      if (e.key === LS_KEY) render();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();